import React from 'react'
import { motion } from "framer-motion"
import service_bg from "../assets/images/services/services-4.jpg"
import { getServiceDate, getServiceData } from '../utlits/fackData/classData';
import WsdForm from '../components/sections/wsdForm' 
import PageTitle from '../components/common/pageTitle'
import { ScrollRestoration } from 'react-router-dom'
import { zoomIn } from '../utlits/zoomIn'

const WsdDetails = () => {
  const wsdDate = getServiceDate(4); // Gets Women's Self Defense details
  const serviceData = getServiceData(4); // Gets complete service data including dates
  
  return (
    <>
      <PageTitle link={"Women's Self Defense Details"} pageName={"Women's Self Defense Details"} />
      <div className="services-details-area pt-100 pb-75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <motion.div className="image"
                initial="offscreen"
                whileInView="onscreen"
                variants={zoomIn(1)}
                viewport={{ once: true, amount: 0 }}
              >
                <img src={service_bg} alt="Women's Self Defense Class" />
              </motion.div>
            </div>
            <div className="col-lg-6">
              <h1>Women's Self Defense Class</h1>
              <h2>$80 | {wsdDate}</h2>
              <br />

              <h3>Woodlawn<br />
              1450 Hwy 98 E Columbia, MS 39429</h3>
              <p>Empower yourself with life-saving skills and awareness. Please note that this does involve physical activity as it is a mixture of physical self defense as well as some mixed martial arts type maneuvers. </p>
              <br />
              <p>After you complete the form, you will be taken to our payment page. Your payment is required to reserve your seat immediately.
              If you have any questions or concerns please contact us at j5solutionssp@gmail.com. You can also call or text (601)633-1159.
              We look forward to training with you.</p>
            </div>
          </div>
        </div>
        <div className="services-details-area pt-100 pb-75"> 
          <WsdForm serviceData={serviceData} />
        </div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default WsdDetails